// @flow
import {
  fetchBlogCategories, fetchBlogIndex,
  fetchBlogPosts,
  generateCategorySlugs
} from '../../../../services/contentfulPosts'
import * as React from 'react'
import type { AppStateType } from '../../../../reducers/appstate'
import type { Dispatch } from 'redux'
import { withRouter } from 'next/router'
import { connect } from 'react-redux'
import type {
  BlogPostType,
  BlogCategoryType,
  CategorySlugsType,
  BlogIndexPageType, FetchBlogPostsQueryParamsType
} from '../../../../services/contentfulPosts'
import HtmlHead from '@components/HtmlHead'
import { Col, Container, Row } from 'react-awesome-styled-grid'
import BlogHeader from '@components/blog/BlogHeader'
import BlogSummary from '@components/blog/BlogSummary'
import { colors, GlobalStyle } from '@components/shared'
import Footer from '@components/Footer'
import styled from 'styled-components'
import TopNav from '@components/TopNav'
import TopNavMobile from '@components/TopNavMobile'
import BlogEmailCaptureModal from '@components/blog/BlogEmailCaptureModal'
import DriveToDownload from '@components/DriveToDownload'
import BackgroundGradient from '@components/BackgroundGradient'

type PropsType = {
  categories: BlogCategoryType[],
  blogPosts: BlogPostType[],
  blogIndexPage: BlogIndexPageType,
  queryParams: FetchBlogPostsQueryParamsType,
  router: {
    query: {
      slug?: string
    }
  }
}

function Blog ({ categories, blogPosts, blogIndexPage, queryParams, router }: PropsType): React.Node {
  if (!blogPosts) {
    return <div>loading</div>
  }

  const [blogs, setBlogs] = React.useState<BlogPostType[]>(blogPosts)
  const [activeCategory, setActiveCategory] = React.useState<string | null>(router.query.slug || null)
  if (router.query.slug !== activeCategory) {
    setActiveCategory(router.query.slug || null)
    setBlogs(blogPosts)
  }

  return (
    <>
      <HtmlHead
        title={'Dipsea | Blog'}
        description={'Opening up the dialogue around modern intimacy and diving into the ideas and stories that light us up and move the conversation around sexuality forward.'}
      />
      <GlobalStyle backgroundColor={colors.violet} />
      <BlogHeaderContainer>
        <BackgroundGradient
          quadrant={1}
          gradientColor={colors.violet}
          gradientPosition='bottom'
          overlayColor='magenta'
          parallax
        />
        <TopNav backgroundColor={colors.violet95} isAssetLoaded={true} isBlog={true} />
        <TopNavMobile backgroundColor={colors.violet95} isAssetLoaded={true} isBlog={true} />
        <Container>
          <BlogEmailCaptureModal />
          <BlogHeader categories={categories} subtitle={blogIndexPage.subtitle} title={blogIndexPage.title} />
        </Container>
      </BlogHeaderContainer>
      <Container>
        <Row>
          <Col xs={4} sm={8} lg={10} offset={{
            lg: 1,
            xl: 1
          }}>
            {blogs.map((blog: BlogPostType): React.Node => (<BlogSummary blog={blog} key={blog.id} />))}
          </Col>
        </Row>
      </Container>
      <Container>
        <Row align='center' justify='center'>
          <Col>
            <ListenContainer>
              <DriveToDownload dontShowPhoneImage />
            </ListenContainer>
          </Col>
        </Row>
      </Container>
      <Footer backgroundColor={colors.midnightBlue} />
    </>
  )
}
type ContextType = {
  params: {
    slug: string,
    id: string
  }
}
export async function getStaticProps (context: ContextType): Promise<{props: $Shape<PropsType>}> {
  const categories = await fetchBlogCategories()
  let id = context.params.id
  const slug = context.params.slug
  if (!id) {
    const filtered = categories.filter((cat: BlogCategoryType): boolean => cat.name.toLowerCase() === slug.toLowerCase())
    id = filtered[0].id
  }
  const queryParams = { categoryId: id }
  const [blogPosts, blogIndexPage] = await Promise.all([fetchBlogPosts(queryParams), fetchBlogIndex()])
  return {
    props: {
      blogIndexPage,
      categories,
      blogPosts,
      queryParams
    }
  }
}

export async function getStaticPaths (): Promise<CategorySlugsType> {
  const paths = await generateCategorySlugs()
  return paths
}

const mapStateToProps = (state: AppStateType, ownProps: PropsType): any => {
  return {
    ...ownProps
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Blog))

const ListenContainer = styled.div`
`

const BlogHeaderContainer = styled.div`
  position: relative;
`
